<template>
	<div>
        <div :id="'id'+id" :style="tabulator ? 'height:30px' : 'height:100px'">
            <span v-if="tabulator">
                <b-button v-if="tabulator" v-b-modal="'i-'+ id" variant="link">
                    <draggable v-if="edit" style="display:inline-block" @change="move" :group="'videos'" :list="videos" class="list-group" handle=".handle">
                        <span v-for="(video, idx) in videos.slice(0, 10)" :key="idx">
                            <img @load="onImgLoad" :id="id+'-t-' + idx" :class="'c' + id + ' handle'" :src='"https://img.youtube.com/vi/" + video.url.replace(/.*\//, "").replace(/.*v=/, "").replace(/&.*/, "") + "/hqdefault.jpg"' :style="'max-height: 30px;margin-right:10px; border:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red 3px solid' : ((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green 3px solid' : 'black 0px solid')" />
                            <!-- <b-tooltip custom-class="long-tooltip" :target="id+'-t-' + idx">{{ JSON.stringify(video, null, "    ") }}
                            </b-tooltip> -->
                        </span>
                    </draggable>
                    <span v-else>
                        <span v-for="(video, idx) in videos.slice(0, 10)" :key="idx">
                            <img @load="onImgLoad" :id="id+'-t-' + idx" :class="'c' + id" :src='"https://img.youtube.com/vi/" + video.url.replace(/.*\//, "").replace(/.*v=/, "").replace(/&.*/, "") + "/hqdefault.jpg"' :style="'max-height: 30px;margin-right:10px; border:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red 3px solid' : ((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green 3px solid' : 'black 0px solid')" />
                            <!-- <b-tooltip custom-class="long-tooltip" :target="id+'-t-' + idx">{{ JSON.stringify(video, null, "    ") }}
                            </b-tooltip> -->
                        </span>
                    </span>
                    <span :class="'c' + id" v-show="videos.length > 10">+ {{videos.length - 10}} videos</span>
                </b-button>
                <b-button v-if="edit" v-b-modal="'edit-i-'+ id" variant="link">
                    <i class="fas fa-plus"></i>
                </b-button>
            </span>
            <div v-else>
                <draggable v-if="edit" style="display:inline-block" @change="move" :group="'videos'" :list="videos" class="list-group" handle=".handle">
                    <span v-for="(video, idx) in videos.slice(0, 10)" :key="idx">
                        <img :id="id+'-i2-' + idx" @load="onImgLoad" :class="'c' + id + ' handle'" :src='"https://img.youtube.com/vi/" + video.url.replace(/.*\//, "").replace(/.*v=/, "").replace(/&.*/, "") + "/hqdefault.jpg"' :style="'max-height: 100px;margin-right:10px; margin-bottom:10px; border:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red 3px solid' : ((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green 3px solid' : 'black 0px solid')" />
                        <b-tooltip custom-class="long-tooltip" :target="id+'-i2-' + idx">{{ JSON.stringify(video, null, "   ") }}
                            </b-tooltip>
                    </span>
                </draggable>
                <span v-else>
                    <span v-for="(video, idx) in videos.slice(0, 10)" :key="idx">
                        <img :id="id+'-i2-' + idx" @load="onImgLoad" :class="'c' + id" :src='"https://img.youtube.com/vi/" + video.url.replace(/.*\//, "").replace(/.*v=/, "").replace(/&.*/, "") + "/hqdefault.jpg"' :style="'max-height: 100px;margin-right:10px; margin-bottom:10px; border:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red 3px solid' : ((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green 3px solid' : 'black 0px solid')" />
                        <b-tooltip custom-class="long-tooltip" :target="id+'-i2-' + idx">
                                {{ video }}
                        </b-tooltip>
                    </span>
                </span>
                <b-button v-if="videos.length > 0 && videos[0].url" v-b-modal="'i-'+ id" variant="link"><span :class="'c' + id" v-if="videos.length > 10">+ {{videos.length - 10}} videos </span><i class="fas fa-search-plus"></i></b-button>
                <b-button v-if="edit" v-b-modal="'edit-i-'+ id" variant="link">
                    <i class="fas fa-plus"></i>
                </b-button>
            </div>
        </div>  
        <b-modal :title="'videos'" size="xl" ok-only :id="'i-'+ id" @show="open = true" @hidden="open = false;">
            <b-button variant="link" @click="list = !list">{{!list ? "Liste" : "videos"}}</b-button>
            <div v-if="open">
                <b-button v-if="edit" v-b-toggle="'edit-ci-'+ id" variant="link">
                    <i class="fas fa-plus"></i>
                </b-button>
                <b-collapse :title="'Ajouter une vidéo Youtube'" size="xl" ok-only :id="'edit-ci-'+ id">
                    Url
                    <b-input v-model="url"></b-input>
                    <br />
                    <b-button @click="add">Ajouter</b-button>
                </b-collapse>
                <br />
                <draggable v-if="edit" style="display:inline-block" @change="move" :group="'videos'" :list="videos" class="list-group" handle=".handle">
                    <div v-for="(video, idx) in videos" :key="idx">
                        <span :class="'handle'" :style="'color:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red' : ((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green' : 'inherit')">{{idx + 1}}/{{videos.length}} - {{video.link || video.url}} - {{video.channel_link ? video.channel_name : "non défini"}}</span>
                        <span v-show="black_white_lists && black_white_lists_edit && !list && video.channel_link"> 
                            <b-button :style="'color:' + (((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green' : '')" variant="link" @click="addList(video.channel_link, 'whitelist')">Whitelist</b-button>                    
                            <b-button :style="'color:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red' : '')" variant="link" @click="addList(video.channel_link, 'blacklist')">Blacklist</b-button>                    
                        </span>
                        <b-button variant="link" @click="deleteList(idx)">Supprimer</b-button>                    
                        <br v-show="!list" />
                        <iframe :class="'handle'" :style="'max-width:100%;margin-bottom:5px;border:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red 3' : ((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green 3' : 'black 1') + 'px solid'" v-show="!list" :id="id+'-i-' + idx" width="100%" height="480" :src="'https://www.youtube.com/embed/' + video.url.replace(/.*\//, '').replace(/.*v=/, '').replace(/&.*/, '')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
                        <b-tooltip custom-class="long-tooltip" :target="id+'-i-' + idx">{{ JSON.stringify(video, null, "    ") }}
                            </b-tooltip>
                        <br />
                    </div>
                </draggable>
                <span v-else>
                    <div v-for="(video, idx) in videos" :key="idx">
                        <span :style="'color:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red' : ((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green' : 'inherit')">{{idx + 1}}/{{videos.length}} - {{video.link || video.url}} - {{video.channel_link ? video.channel_name : "non défini"}}</span>
                        <span v-show="black_white_lists && black_white_lists_edit && !list && video.channel_link"> 
                            <b-button :style="'color:' + (((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green' : '')" variant="link" @click="addList(video.channel_link, 'whitelist')">Whitelist</b-button>                    
                            <b-button :style="'color:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red' : '')" variant="link" @click="addList(video.channel_link, 'blacklist')">Blacklist</b-button>                    
                        </span>
                        <br v-show="!list" />
                        <iframe :class="'handle'" :style="'max-width:100%;margin-bottom:5px;border:' + (((video.state && video.state == 'blacklist') || (!video.state && blacklist.includes(video.channel_link))) ? 'red 3' : ((video.state && video.state == 'whitelist') || (!video.state && whitelist.includes(video.channel_link))) ? 'green 3' : 'black 1') + 'px solid'" v-show="!list" :id="id+'-i-' + idx" width="100%" height="480" :src="'https://www.youtube.com/embed/' + video.url.replace(/.*\//, '').replace(/.*v=/, '').replace(/&.*/, '')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
                        <b-tooltip custom-class="long-tooltip" :target="id+'-i-' + idx">{{ JSON.stringify(video, null, "    ") }}
                            </b-tooltip>
                        <br />
                    </div>
                </span>
            </div>
        </b-modal>
        <b-modal :title="'Ajouter une video Youtube'" size="xl" ok-only :id="'edit-i-'+ id">
            Url
            <b-input v-model="url"></b-input>
            <br />
            <b-button @click="add">Ajouter</b-button>
        </b-modal>        
 	</div>
</template>

<script>
    import database from "../services/database.js";
    import store from "../store";

	import uniqueId from "lodash.uniqueid";
    import draggable from "vuedraggable";

    var clone = require("clone");

    export default {
        name: "videos",
		components: {
            draggable
		},
		props: {
            'source': {},
            'column': {}, 
            'black_white_lists': {},
            'black_white_lists_edit': {},
            "idx": {},
            "tabulator": {
                default: true
            },
            edit: false,
            index: 0
        },
		data() {
			return {
                id: uniqueId(),
                videos: [],
                loaded: 0,
                open: false,
                whitelist: [],
                blacklist: [],
                list: false,
                url: ""
			};
		},
		computed: {
			event() {
				return store.getters.getEvent
			}
		},
		watch: {
            source() {
                this.init();
            },
			event: async function (event) {
                if (this.black_white_lists)
                {
                    if (event == "videos_whitelist")
                    {
                        //console.log(this.whitelist);

                        this.whitelist = store.state.videos_whitelist;
                    }
                    if (event == "videos_blacklist")
                    {
                        this.blacklist = store.state.videos_blacklist;
                    }
                }
			}
		},
		methods: {
            async move() {
                this.$emit('update', this.index, this.column, JSON.stringify(this.videos));
            },
            async add()
            {
                console.log("add");

                this.loaded = 0;

                var videos = this.videos; 
                
                videos.unshift({
                    url: this.url
                });

                this.$emit('update', this.index, this.column, JSON.stringify(videos));

                return;
            },
            async deleteList(idx)
            {
                this.videos.splice(idx, 1);
                this.$emit('update', this.index, this.column, JSON.stringify(this.videos));
            },
            async addList(element, type)
            {
                if (!element)
                    return;

                var _type = null;

                var response = await database.get("select", store.state.client.details.tables_obj.black_white_lists, {
                    select: "*",
                    where: 'element = "' + element + '"'
                });

                if (response.length > 0)
                {
                    for (var i = 0; i < response.length; i++)
                    {
                        await database.get("delete", store.state.client.details.tables_obj.black_white_lists, {
                            where: "id = '" + response[i].id + "'"
                        })
                        _type = response[i].type;
                    }

                    var index = this.blacklist.indexOf(element);
                    if (index != -1)
                    {
                        this.blacklist.splice(index, 1);
                        store.commit("setvideosBlacklist", this.blacklist)
                        await this.$nextTick()
                        store.commit("setEvent", "videos_blacklist");
                        await this.$nextTick()
                        store.commit("setEvent", "");
                    }
                    var index = this.whitelist.indexOf(element);
                    if (index != -1)
                    {
                        this.whitelist.splice(index, 1);
                        store.commit("setVideosWhitelist", this.whitelist)
                        await this.$nextTick()
                        store.commit("setEvent", "videos_whitelist");
                        await this.$nextTick()
                        store.commit("setEvent", "");
                    }
                }

                if (type && type != _type)
                {                    
                    var response = await database.get("insert into", store.state.client.details.tables_obj.black_white_lists, {
                        columns: ['element', 'type', 'image', 'youtube'],
                        data: {
                            element: element,
                            type,
                            image: false,
                            youtube: true
                        }
                    });

                    if (type == "blacklist")
                    {
                        this.blacklist.push(element);

                        store.commit("setVideosBlacklist", this.blacklist)
                        await this.$nextTick()
                        store.commit("setEvent", "videos_blacklist");
                        await this.$nextTick()
                        store.commit("setEvent", "");
                        
                    }
                    if (type == "whitelist")
                    {
                        this.whitelist.push(element);

                        store.commit("setVideosWhitelist", this.whitelist)
                        await this.$nextTick()
                        store.commit("setEvent", "videos_whitelist");
                        await this.$nextTick()
                        store.commit("setEvent", "");
                    }
                }
            },
            test()
            {
                this.$emit('test');
            },
            onImgLoad()
            {
                var self = this;

                this.loaded++;

                if (this.loaded == this.videos.slice(0, 10).length)
                {
                    var elems = document.querySelectorAll(".c" + self.id);
                    var width = 20;
                    for (var i = 0; i < elems.length; i++)
                    {
                        width += elems[i].offsetWidth + 10;
                    }
                    self.$emit('width', width, self.column);
                }
            },
            async init()
            {
                var self = this;
            
                var source = clone(this.source);

                if (!source)
                    source = "[]";

                var videos = [];

                if (source.startsWith("["))
                {
                    source = JSON.parse(source);
                    for (var i = 0; i < source.length; i++)
                    {
                        if (typeof source[i] == "object")
                            videos.push(source[i]);
                        else
                            videos.push({url: source[i]});
                    }
                }
                else if(source.startsWith("{"))
                {
                    source = JSON.parse(source);
                    videos.push(source);
                }
                else
                {
                    videos = [{url: source}];
                }

                if (videos.length > 0)
                {
                    //console.log(videos)
                    if ((!videos[0].url && videos[0].uid) || !videos[0].url.startsWith("h") && videos[0].url.length == 36)
                    {
                        var ids = "";
                        for (var i = 0; i < videos.length; i++)
                        {
                            if (i > 0)
                                ids += ",";
                            ids += '"' + (videos[i].uid || videos[i].url) + '"';
                        }

                        var videos_obj = {};
                        var _videos = await database.get("select", store.state.client.details.tables_obj.characteristic, {
                            select: "*",
                            where: "uid in (" + ids + ") ORDER BY FIELD(uid, " + ids + ")"
                        });

                        for (var i = 0; i < _videos.length; i++)
                        {
                            videos_obj[_videos[i].uid] = JSON.parse(_videos[i].data);
                        }

                        for (var i = 0; i < videos.length; i++)
                        {
                            if (videos_obj[(videos[i].uid || videos[i].url)])
                            {
                                if (videos[i].url && !videos[i].url.startsWith("h") && videos[i].url.length == 36)
                                {
                                    videos[i].uid = videos[i].url;
                                }
                                var key = videos[i].uid || videos[i].url;
                                if (videos[i].url)
                                    delete videos[i].url;
                                videos[i] = Object.assign(videos_obj[key], videos[i]);
                            }
                        }
                    }
                }

                this.videos = videos;

                if (this.black_white_lists)
                {
                    //console.log(this.idx + " - set black_white_lists")

                    var whitelist = store.state.videos_whitelist;
                    var blacklist = store.state.videos_blacklist;

                    if (blacklist == null)
                    {
                        if (this.idx == 1)
                        {
                            //console.log("set black_lists - db")                    
                            var blacklist = [];
                            var response = await database.get("select", store.state.client.details.tables_obj.black_white_lists, {
                                select: "*",
                                where: 'type = "blacklist" and youtube is true'
                            });

                            //console.log(response)

                            for (var i = 0; i < response.length; i++)
                            {
                                blacklist.push(response[i].element);
                            }

                            store.commit("setVideosBlacklist", blacklist)
                            await this.$nextTick()
                            store.commit("setEvent", "viedos_blacklist");
                            await this.$nextTick()
                            store.commit("setEvent", "");
                        }
                    }
                    else
                    {
                        this.blacklist = blacklist;
                    }

                    if (whitelist == null)
                    {
                        if (this.idx == 1)
                        {                    
                            console.log("video - set white_lists - db")                    
                            
                            var whitelist = [];
                            var response = await database.get("select", store.state.client.details.tables_obj.black_white_lists, {
                                select: "*",
                                where: 'type = "whitelist" and youtube is true'
                            });

                            for (var i = 0; i < response.length; i++)
                            {
                                whitelist.push(response[i].element);
                            }

                            store.commit("setVideosWhitelist", whitelist)
                            await this.$nextTick()
                            store.commit("setEvent", "videos_whitelist");
                            await this.$nextTick()
                            store.commit("setEvent", "");
                        }
                    }
                    else
                    {
                        this.whitelist = whitelist;
                    }
                }
            }
		},
		mounted: async function () {
            this.init();
		},
	};
</script>

<style>
.tooltip-inner {
    white-space: pre-wrap;
}
</style>
